export default __webpack_public_path__ + "static/media/before.b6196d7f.mp3";